import { Component, computed, forwardRef, input } from "@angular/core";
import { FilterBlocksPipe } from "../../../../common/pipes/filter-blocks.pipe";
import { sanitizeDirectusArray } from "../../../../common/utils/sanitize-directus-object";
import { ItemsAdLayoutBlock } from "../../../api/packbo/models/items-ad-layout-block";
import { DynamicPageComponent } from "../dynamic-page/dynamic-page.component";

@Component({
    selector: "packbo-ad-layout-block",
    templateUrl: "./ad-layout-block.template.html",
    imports: [FilterBlocksPipe, forwardRef(() => DynamicPageComponent)]
})
export class AdLayoutBlockComponent {
    public readonly adLayoutBlock = input.required<ItemsAdLayoutBlock>();

    protected readonly nestedBlocks = computed(() => sanitizeDirectusArray(this.adLayoutBlock().blocks_refs));
    protected readonly hasResourceBlock = computed(() =>
        this.nestedBlocks().some((block) => block.collection === "resource_block")
    );
    protected readonly hasPackageBlock = computed(() =>
        this.nestedBlocks().some((block) => block.collection === "package_block")
    );
    protected readonly hasAdPackagesBlock = computed(() =>
        this.nestedBlocks().some((block) => block.collection === "ad_packages_block")
    );
    protected readonly adLayoutClasses = computed(() => {
        if (this.hasResourceBlock() || this.hasPackageBlock()) {
            return "px-12 lg:flex";
        }
        if (this.hasAdPackagesBlock()) {
            return "px-40 lg:flex";
        }
        return "pr-12 pl-4 md:pl-20 lg:flex lg:pl-40 xl:gap-20 xl:pl-20 2xl:gap-30 2xl:pl-30";
    });
}
